import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=65e2784b&scoped=true&"
import script from "./ButtonBase.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ButtonBase.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ButtonBase.vue?vue&type=style&index=0&id=65e2784b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e2784b",
  null
  
)

export default component.exports